import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue';

interface IProps {
  title: string;
  classes?: string[];
  noMargin?: boolean;
  fontSize?:string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomTitle',
  props: {
    title: {},
    classes: {},
    noMargin: { type: Boolean },
    fontSize: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", {
    style: _normalizeStyle({ marginBottom: _ctx.noMargin ? 0 : '16px', fontSize: _ctx.fontSize? _ctx.fontSize:'' }),
    class: _normalizeClass(_ctx.classes)
  }, _toDisplayString(props.title), 7))
}
}

})